import React from 'react';
import PropTypes from 'prop-types';
import {
  StyleList,
  StyleItem,
  StyleOptions,
  StyleLanguageCertificate,
  StyleBoxEmployee,
  StyleEditIcon
} from './style';

import { Pencil } from '../../../../assets/images/index';

const Resume = (dataLanguage, limit) => (
  <StyleList>
    {dataLanguage.slice(0, limit).map(item => (
      <StyleItem key={item.name}>
        {item.name}{' '}
        {item.proficiency && (
          <StyleOptions>
            ({item.proficiency}
            {item.certification && (
              <StyleLanguageCertificate>
                : {item.certification}
              </StyleLanguageCertificate>
            )}
            )
          </StyleOptions>
        )}
      </StyleItem>
    ))}
  </StyleList>
);

const Languages = ({ limit, dataLanguage, onEditMode, clickEditIcon }) => (
  <StyleBoxEmployee
    title="Idiomas"
    more={dataLanguage && dataLanguage.length > limit}
    moreInfo={Resume(dataLanguage, dataLanguage ? dataLanguage.length : 0)}
  >
    {onEditMode && (
      <StyleEditIcon
        svg={Pencil}
        size="m"
        color="dark"
        hover
        onClick={clickEditIcon}
      />
    )}
    {Resume(dataLanguage, limit)}
  </StyleBoxEmployee>
);

Languages.propTypes = {
  dataLanguage: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      proficiency: PropTypes.string,
      certification: PropTypes.string
    })
  ),
  limit: PropTypes.number,
  onEditMode: PropTypes.bool,
  clickEditIcon: PropTypes.func
};

export default Languages;
